import queryString from 'query-string'

import { apiService, fetchingAPI } from '@/api'

// The shared Balto knowledge base is one collection served to every
// organization, so its endpoints are not org-scoped the way /files/{orgId} is.
// agent-gpt gates them on Balto org 1 (`require_balto_admin`), so they go out
// with organizationid=1 — the caller's OWN org, not whichever customer org a
// Balto admin happens to be viewing. Same arrangement, for the same reason, as
// googleDriveConnection.actions.js.
const BALTO_KNOWLEDGE_BASE = () => `${apiService.agentGpt}/balto_knowledge`
const USE_OWN_ORG = true

// The callers surface their own messages, so suppress the generic 500 toast
// rather than showing two.
const DETAILS = { isSilent: true }

export const fetchBaltoProductFeatures = () => async (dispatch) =>
  fetchingAPI(
    `${BALTO_KNOWLEDGE_BASE()}/product_features`,
    'GET',
    dispatch,
    undefined,
    undefined,
    DETAILS,
    USE_OWN_ORG
  )

export const fetchBaltoKnowledgeDocuments = () => async (dispatch) => {
  const data = await fetchingAPI(
    BALTO_KNOWLEDGE_BASE(),
    'GET',
    dispatch,
    undefined,
    undefined,
    DETAILS,
    USE_OWN_ORG
  )
  // The endpoint returns a bare array. Guarding means a shape change shows up as
  // an empty list rather than a render crash.
  return Array.isArray(data) ? data : []
}

export const uploadBaltoKnowledgeDocument =
  ({ file, features = [] }) =>
  async (dispatch) => {
    // No features means the document applies to every organization; the picker's
    // "All features" option is stored exactly this way. stringify drops an empty
    // array, so that case sends no param at all.
    const params = queryString.stringify({ features })

    const formData = new FormData()
    formData.append('file', file)

    // Content-Type is left unset so the browser supplies the multipart boundary.
    return fetchingAPI(
      `${BALTO_KNOWLEDGE_BASE()}?${params}`,
      'POST',
      dispatch,
      formData,
      undefined,
      DETAILS,
      USE_OWN_ORG,
      undefined,
      false
    )
  }

export const deleteBaltoKnowledgeDocument =
  ({ filePath }) =>
  async (dispatch) =>
    fetchingAPI(
      `${BALTO_KNOWLEDGE_BASE()}?${queryString.stringify({ file_path: filePath })}`,
      'DELETE',
      dispatch,
      undefined,
      undefined,
      DETAILS,
      USE_OWN_ORG
    )
